<template>
  <div id="game-wrapper">
    <div id="title-screen" :class="{'active':showTitleScreen}"  @click="startGame" @touchstart="startGame">
      <img id="title-img" src="../src/assets/img/titel-bild.jpg">
      <img src="../src/assets/img/titel.jpg">
    </div>
    <div id="game" :class="{'active':showGame}">
      <img src="../src/assets/img/passionsaltar.jpg">
    </div>
    <div id="draggables" :class="{'active': showGame}">
      <div
        v-for='item in draggableItems'
        :key='item.id'
        :id="item.name"
        :class="{ 'active': item.active, draggable: true, dragged: item.dragged, placed: item.placed}"
        @touchstart='startDrag($event, item)'
        @mousedown='startDrag($event, item)'
        @touchend='dragEnd($event, item)'
        @mouseup='dragEnd($event, item)'
      >
        <img :src="require('@/assets/img/'+ item.name + '.png')" alt="item.name">
      </div>
    </div>
    <div
      v-for="item in dropableItems"
      :key="item.id"
      :id="item.name"
      :class="{'dropable': true, 'dropped': item.dropped}"
      @drop='onDrop($event, 1)'
      @dragover.prevent
      @dragenter.prevent
    ></div>
    <div class="message active" v-if="message" v-on:click="closeMessage">
      <div :class="{'popup': true, 'wide': widerMessage}">
        <p v-html="messageContent"></p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Passionsaltar',
  data () {
    return {
      $dragElement: null,
      dragItem: null,
      showTitleScreen: true,
      showGame: false,
      message: false,
      messageContent: '',
      widerMessage: false,
      messages: [
        { id: 0, html: '<b>Look very carefully </b> and match the objects to the scenes or people on the altar. ' },
        { id: 1, html: '<b>Well done! </b> You found everything. ' }
      ],
      draggableItems: [
        { id: 0, name: 'Gugel', html: 'This is a <b>cowl</b>. It’s a kind of hood with a collar covering the shoulders. It was usually made of simple woolen fabric, but for rich people, they were also made of expensive fabrics or even with a fur trim – like here in the picture.', required: 'Gugel-Drop', active: true },
        { id: 1, name: 'Hahn', html: '<b>The rooster</b> is crowing – Jesus predicts that his disciple Peter will deny him three times in one night before the rooster crows in the morning. This is exactly what happens and Peter deeply regrets that he wasn’t strong enough to stand up for his faith and Jesus.', required: 'Hahn-Drop', active: false },
        { id: 2, name: 'Haube', html: 'In the Middle Ages, married women had to cover their hair with a <b>bonnet</b>. Unmarried women were allowed to show their hair. This is where the German expression “to come under the bonnet” comes from when someone gets married. ', required: 'Haube-Drop', active: false },
        { id: 3, name: 'Skorpion', html: '<b>The scorpion</b> is often used as a sign of evil. Here it can be seen on the flag, signifying the group of Jesus` enemies.', required: 'Skorpion-Drop', active: false },
        { id: 4, name: 'Trippen', html: 'In the Middle Ages it was fashionable, especially for rich people, to wear long pointy shoes. This is where the German expression “auf großem Fuß leben” or “to live on large feet” comes from. This means so much as “to live a high life”. The platform soles are made out of wood and are called <b>pattens</b>. They also helped protect people’s feet from the cold and dirt.', required: 'Trippen-Drop', active: false }
      ],
      dropableItems: [
        { id: 5, name: 'Gugel-Drop', dropped: false },
        { id: 6, name: 'Hahn-Drop', dropped: false },
        { id: 7, name: 'Haube-Drop', dropped: false },
        { id: 8, name: 'Skorpion-Drop', dropped: false },
        { id: 9, name: 'Trippen-Drop', dropped: false }
      ],
      placedItems: [],
      touchmoveEventListener: (evt) => { this.drag(evt) },
      touchendEventListener: (evt) => { this.dragEnd(evt) }
    }
  },
  methods: {
    startGame () {
      this.showTitleScreen = false
      this.showGame = true
      setTimeout(this.showMessage, 10, this.messages[0].html)
    },
    startDrag (evt, item) {
      evt.preventDefault()
      evt.stopPropagation()
      if (!this.placedItems.includes(item.id)) {
        this.$dragElement = evt.target
        if (this.$dragElement.nodeName === 'IMG') this.$dragElement = this.$dragElement.parentNode
        const box = this.$dragElement.getBoundingClientRect()
        const c = evt.type.match(/^touch/) ? evt.touches[0] : evt
        this.$dragElement.mouseOffset = { x: c.clientX - box.left, y: c.clientY - box.top }
        this.$dragElement.style.left = (c.clientX - this.$dragElement.mouseOffset.x - this.$el.offsetLeft) + 'px'
        this.$dragElement.style.top = (c.clientY - this.$dragElement.mouseOffset.y - this.$el.offsetTop) + 'px'
        this.$set(item, 'dragged', true)
        this.dragItem = item
        window.addEventListener(evt.type === 'mousedown' ? 'mousemove' : 'touchmove', this.touchmoveEventListener)
        window.addEventListener(evt.type === 'mousedown' ? 'mouseup' : 'touchend', this.touchendEventListener)
      }
    },
    drag (evt) {
      evt.preventDefault()
      evt.stopPropagation()
      if (this.$dragElement && this.$dragElement.mouseOffset) {
        const c = evt.type.match(/^touch/) ? evt.touches[0] : evt
        this.$dragElement.style.left = (c.clientX - this.$dragElement.mouseOffset.x - this.$el.offsetLeft) + 'px'
        this.$dragElement.style.top = (c.clientY - this.$dragElement.mouseOffset.y - this.$el.offsetTop) + 'px'
      }
    },
    dragEnd (evt) {
      if (this.dragItem) {
        const c = evt.type.match(/^touch/) ? evt.changedTouches[0] : evt
        const box = this.dragItem.required ? this.$el.querySelector('#' + this.dragItem.required).getBoundingClientRect() : null
        if (box) {
          const clickMargin = box.width / 4
          if (box.left < c.clientX && box.right - clickMargin > c.clientX && box.top < c.clientY && box.bottom > c.clientY) {
            this.onDrop()
            return
          }
        }
        this.resetDragElement()
        this.removeEventListeners()
        this.$dragElement = null
        this.dragItem = null
      }
    },
    onDrop () {
      if (this.dragItem) {
        this.showMessage(this.dragItem.html)
        this.draggableItems[this.placedItems.length].active = false
        this.placedItems.push(this.dragItem.id)
        for (var n = 0; n < this.dropableItems.length; n++) {
          if (this.dropableItems[n].name === this.dragItem.required) this.dropableItems[n].dropped = true
        }
        if (this.placedItems.length < this.draggableItems.length) this.draggableItems[this.placedItems.length].active = true
        this.$dragElement = null
        this.dragItem = null
      }
    },
    resetDragElement () {
      if (this.$dragElement) {
        this.$dragElement.style.zIndex = 'auto'
        this.$dragElement.style.left = null
        this.$dragElement.style.top = null
        this.$set(this.dragItem, 'dragged', false)
      }
    },
    removeEventListeners () {
      window.removeEventListener('mousemove', this.touchmoveEventListener)
      window.removeEventListener('touchmove', this.touchmoveEventListener)
      window.removeEventListener('mouseup', this.touchendEventListener)
      window.removeEventListener('touchend', this.touchendEventListener)
    },
    closeMessage () {
      this.message = false
      this.messageContent = ''
      if (this.placedItems.length === this.draggableItems.length) {
        this.placedItems.push('ende')
        this.showMessage(this.messages[1].html)
      }
    },
    showMessage (htmlText) {
      this.message = true
      this.widerMessage = htmlText.length > 150
      this.messageContent = htmlText
    }
  }
}
</script>
